import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { GenericError } from '@cian/peperrors/shared';
export var MapVersionError = /*#__PURE__*/function (_GenericError) {
  function MapVersionError(domain, currentVersion, requiredVersion) {
    _classCallCheck(this, MapVersionError);
    return _callSuper(this, MapVersionError, [{
      domain: domain,
      message: 'Версия используемого Yandex api не соответствует требуемой!',
      type: 'InvalidYandexMapsVersion',
      details: {
        currentVersion: currentVersion,
        requiredVersion: requiredVersion
      }
    }]);
  }
  _inherits(MapVersionError, _GenericError);
  return _createClass(MapVersionError);
}(GenericError);